module.exports = __webpack_public_path__ + "static/media/logo_long.66ecfdcb.png";